import React from 'react';

import withWindowResize from '../../ui/components/window-resize';

export default withWindowResize(
    ({
        className,
        device,
        showFor = ['mobile', 'tablet', 'desktop'],
        children
    }) => {
        return showFor.includes(device) ? <div
            className={`badge-banner clearfix ${
                className ? ' ' + className : ''
            }`}
        >
            {children}
        </div> :  null
    }
);
